import { cognitoUserManager, getCognitoSignOutRedirectUrl } from '@/config/authConfig';
import { showError } from '@/shared';

class AuthService {
  async signIn(): Promise<void> {
    try {
      await cognitoUserManager.signinRedirect();
    } catch (e) {
      showError(e);
    }
  }

  signOut(): void {
    try {
      cognitoUserManager.removeUser();
      window.location.assign(getCognitoSignOutRedirectUrl());
    } catch (e) {
      showError(e);
    }
  }

  async signinRedirectCallback() {
    try {
      return await cognitoUserManager.signinCallback();
    } catch (e) {
      showError(e);
      return null;
    }
  }
}

export default new AuthService();
